import axios from 'axios'
import { host } from '../../configuraciones'
import { v4 as uuidv4 } from 'uuid';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

//constantes
const dataInicial = {
    data: {},
    fc_08: {},
    certificados: {},
    loading: false,
    paginaActiva: 1,
    fc_08Map: {},
    certificadosMap: [],
    filesExportacionMap: [],
    filesGranelMap: [],
    modoVerDetalle: false,
    modoRecibidasCorregidas: false,
    modoProceso: false
}

//types
const ACTUALIZAR_FC_08_PAGINA = 'ACTUALIZAR_FC_08_PAGINA'
const ACTUALIZAR_FC_08_ESTATUS_EXITO = 'ACTUALIZAR_FC_08_ESTATUS_EXITO'
const ACTUALIZAR_FC_08_MAP_EXITO = 'ACTUALIZAR_FC_08_MAP_EXITO'
const AGREGAR_ANEXO_FC_08_EXITO_MAP = 'AGREGAR_ANEXO_FC_08_EXITO_MAP'
const OBTENER_ID_CLIENTE_EXITO = 'OBTENER_ID_CLIENTE_EXITO'
const OBTENER_FC_08_MAP_EXITO = 'OBTENER_FC_08_MAP_EXITO'
const AGREGAR_FC_08_EXITO = 'AGREGAR_FC_08_EXITO'
const AGREGAR_FC_08_MAP_EXITO = 'AGREGAR_FC_08_MAP_EXITO'
const OBTENER_FC_08_DETALLE_EXITOAT = 'OBTENER_FC_08_DETALLE_EXITOAT'
const AGREGAR_FC_08_EXITO_MAP = 'AGREGAR_FC_08_EXITO_MAP'
const GENERAR_OFICIOS_FC08_EXITO = 'GENERAR_OFICIOS_FC08_EXITO'
const AGREGAR_FC_08_FORMULARIO_EXITO = 'AGREGAR_FC_08_FORMULARIO_EXITO'

export const actualizarFC_08Estatus = createAsyncThunk(
    ACTUALIZAR_FC_08_ESTATUS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusTablas'
            const result = await axios.post(fullUrl, data)
            return true
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerFC_08SolicitudDetalle = createAsyncThunk(
    OBTENER_FC_08_DETALLE_EXITOAT,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_08/obtenerFormatoFC08_ConDetalle/${idSolicitud}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const agregarMapFC_08Accion = createAsyncThunk(
    AGREGAR_FC_08_EXITO_MAP,
    async (data) => {
        try {
            const agregarFC_08Map = host + `MapSolicitud/agregarMapFC_08_Solicitud`
            const agregarAnexosFC_08Map = host + `MapSolicitud/agregarMapFC_08_AnexoRenovacionDeCertificado`
            const agregarArchivosExportacionMap = host + `MapSolicitud/agregarMapFC_08_ArchivosExportacion`
            const agregarArchivosGranelMap = host + `MapSolicitud/agregarMapFC_08_ArchivosGranel`
            const res = await axios.post(agregarFC_08Map, { data: data.solicitud })
            for (const i in data?.certificadosMap) {
                await axios.post(agregarAnexosFC_08Map, { data: data?.certificadosMap?.[i] })
            }
            for (const i in data?.archivosExportacionMap) {
                await axios.post(agregarArchivosExportacionMap, { data: data?.archivosExportacionMap?.[i] })
            }
            for (const i in data?.archivosGranelMap) {
                await axios.post(agregarArchivosGranelMap, { data: data?.archivosGranelMap?.[i] })
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC_08Solicitud = createAsyncThunk(
    AGREGAR_FC_08_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const certificados = data.rowspagina2
            const actualizarFC_08 = host + `FC_08/actualizarFC_08`
            const urlActualizarCertificados = host + 'FC_08/actualizarFormatoFC08_AnexoCertificados'
            const urlActualizarArchivosGranel = host + 'FC_08/actualizarArchivoGranel'

            const res = await axios.put(actualizarFC_08, solicitud)
            for (const i in certificados) {
                let dato = { idfc08_anexorenovacion: certificados?.[i].idfc08_anexorenovacion, numerocertificado: certificados?.[i].numerocertificado }
                await axios.put(urlActualizarCertificados, { data: dato })
            }
            for (const i in data.archivosGranel) {
                let resAnexo = await axios.put(urlActualizarArchivosGranel, { data: data?.archivosGranel?.[i] })
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerFC_08Map = createAsyncThunk(
    OBTENER_FC_08_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_08_Solicitud/${solicitudId}`
            const res = await axios.get(fullUrl)

            const certificadosMap = await obtenerCertificadosMap(solicitudId)

            const solicitudMap = {
                data: res.data.data,
                anexoCertificadoMap: certificadosMap.anexoCertificadoMap,
                archivoExportacionMap: certificadosMap.archivoExportacionMap,
                archivoGranelMap: certificadosMap.archivoGranelMap
            }
            return solicitudMap
        } catch (error) {
            console.log(error)
        }
    }
)
const obtenerCertificadosMap = async (idSolicitud) => {
    try {
        const fullUrl = host + `FC_08/obtenerFormatoFC08_ConDetalle/${idSolicitud}`
        const obtenerCertificadosMap = host + `MapSolicitud/obtenerMapFC_08_AnexoRenovacionDeCertificado/`
        const obtenerArchivoExportacionMap = host + `MapSolicitud/obtenerMapFC_08_ArchivosExportacion/`
        const obtenerArchivoGranelMap = host + `MapSolicitud/obtenerMapFC_08_ArchivosGranel/`
        const res = await axios.get(fullUrl)
        console.log("los datos de res ", res.data.data)
        let anexoCertificadoMap = []
        for (const anexo of res.data.data.fc_08_anexocertificados) {
            const resMap = await axios.get(obtenerCertificadosMap + anexo.idfc08_anexorenovacion)
            anexoCertificadoMap.push(resMap.data.data)
        }
        let archivoExportacionMap = []
        for (const i in res.data.data.fc_08archivosexportacion) {
            const resMap = await axios.get(obtenerArchivoExportacionMap + res.data.data.fc_08archivosexportacion?.[i].idfc_08archivosexportacion)
            archivoExportacionMap.push(resMap.data.data)
        }
        let archivoGranelMap = []
        for (const anexo of res.data.data.fc_08_anexocertificados) {
            if (anexo.tipocertificado === 'Granel') {
                for (const i in anexo.fc_08archivosgranel) {
                    const resMap = await axios.get(obtenerArchivoGranelMap + anexo.fc_08archivosgranel?.[i].idfc_08archivoscertificados)
                    archivoGranelMap.push(resMap.data.data)
                }
            }
        }

        return { anexoCertificadoMap: anexoCertificadoMap, archivoExportacionMap: archivoExportacionMap, archivoGranelMap: archivoGranelMap }
    } catch (error) {
        console.log(error);
    }
}
export const actualizarFC_08MapSolicitud = createAsyncThunk(
    ACTUALIZAR_FC_08_MAP_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const certificadosMap = data.certificadosMap
            const archivosExportacionMap = data.archivosExportacionMap
            const archivosGranelMap = data.archivosGranelMap

            const actualizarFC_08 = host + 'MapSolicitud/actualizarMapFC_08_Solicitud'
            const urlActualizarAnexoCertificados = host + 'MapSolicitud/actualizarMapFC_08_AnexoRenovacionDeCertificado'
            const urlActualizarFilesExportacion = host + 'MapSolicitud/actualizarMapFC_08_ArchivosExportacion'
            const urlActualizarFilesGranel = host + 'MapSolicitud/actualizarMapFC_08_ArchivosGranel'

            const res = await axios.put(actualizarFC_08, solicitud)

            for (const i in certificadosMap) {
                await axios.put(urlActualizarAnexoCertificados, { data: certificadosMap[i] })
            }
            for (const i in archivosGranelMap) {
                await axios.put(urlActualizarFilesGranel, { data: archivosGranelMap[i] })
            }
            return data

        } catch (error) {
            console.log(error)
        }
    }
)

export const obtenerIdCliente = createAsyncThunk(
    OBTENER_ID_CLIENTE_EXITO,
    async (idlogin) => {
        try {
            const fullUrl = host + `AnexoUsuario/obtenerClientePorIdLogin/${idlogin}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)
export const generarDocumentosFC_08 = createAsyncThunk(
    GENERAR_OFICIOS_FC08_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'AtencionAClientes/generarOficios'
            const result = await axios.post(fullUrl, data)
            return {}
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarFC_08SolicitudFomulario = createAsyncThunk(
    AGREGAR_FC_08_FORMULARIO_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data }
            const actualizarFC_08 = host + `FC_08/actualizarFC_08`
            const res = await axios.put(actualizarFC_08, solicitud)
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const fc08Slice = createSlice({
    name: 'fc08Slice',
    initialState: dataInicial,
    reducers: {
        actualizarPaginaActivaFC_08(state, { payload }) {
            state.paginaActiva = payload
        },
        resetDataFC_08(state, { payload }) {
            return dataInicial
        },
        agregarFC_08AnexoCertificado(state, { payload }) {
            state.certificados.data.push(payload)
        },
        guardarCambiosFC_08Solicitud(state, { payload }) {
            state.fc_08 = payload
        },
        setModoVerDetalleFC_08(state, { payload }) {
            state.modoVerDetalle = payload
        },
        setModoRecibidasCorregidasFC_08(state, { payload }) {
            state.modoRecibidasCorregidas = payload
        },
        setModoProcesoFC_08(state, { payload }) {
            state.modoProceso = payload
        },
    },
    extraReducers: {
        [obtenerFC_08SolicitudDetalle.fulfilled]: (state, { payload }) => {
            state.data = payload
        },
        [agregarMapFC_08Accion.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_08Estatus.fulfilled]: (state, { payload }) => {
        },
        [obtenerIdCliente.fulfilled]: (state, { payload }) => {
        },
        [obtenerFC_08Map.fulfilled]: (state, { payload }) => {
            state.fc_08Map = payload.data
            state.certificadosMap = payload.anexoCertificadoMap
            state.filesExportacionMap = payload.archivoExportacionMap
            state.filesGranelMap = payload.archivoGranelMap
        },
        [actualizarFC_08Solicitud.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_08MapSolicitud.fulfilled]: (state, { payload }) => {
        },
    },
})

//actions
export const {
    actualizarPaginaActivaFC_08,
    resetDataFC_08,
    agregarFC_08AnexoCertificado,
    guardarCambiosFC_08Solicitud,
    setModoVerDetalleFC_08, setModoRecibidasCorregidasFC_08, setModoProcesoFC_08
} = fc08Slice.actions

export const FC08ReducerAtencionACliente = fc08Slice.reducer